export class ActionUserFilter {
  customerID: string;
  action: string;
  beginningDate: string;
  endDate: string;
  user: string;

  constructor(customerId: string) {
    this.customerID = customerId;
    this.beginningDate = null;
    this.endDate = null;
    this.user = null;
  }

  public formatDate(date: Date | null): string {
    if(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');  // getMonth() retourne un index de 0 (janvier) à 11 (décembre)
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');

      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } else {
      return null;
    }
  }
}
